import React, { useState } from 'react';
import { Modal, Input, Button, Table, Space, message, Popconfirm } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, GlobalOutlined, SaveOutlined, CloseOutlined } from '@ant-design/icons';
import MultilingualDialog from './MultilingualDialog';

/**
 * 套餐标签 / 套餐描述标签 管理弹窗（真实项目 tagDialog.vue）
 * type: 1=描述标签, 2=套餐标签
 */
const TagDialog = ({ open, type = 2, list = [], onCancel, onChange }) => {
    const [inputName, setInputName] = useState('');
    const [editingId, setEditingId] = useState(null);
    const [editingName, setEditingName] = useState('');
    const [i18n, setI18n] = useState({ open: false, originValue: '' });

    const dialogTitle = type === 1 ? '管理描述标签' : '管理套餐标签';

    const handleAdd = () => {
        const name = inputName.trim();
        if (!name) { message.warning('请输入标签名称'); return; }
        if (list.some(t => t.name === name)) { message.warning('标签名称已存在'); return; }
        onChange([...list, { id: `tag_${Date.now()}`, name }]);
        setInputName('');
        message.success('添加成功');
    };

    const handleSaveEdit = (row) => {
        const name = editingName.trim();
        if (!name) { message.warning('标签名称不能为空'); return; }
        onChange(list.map(t => (t.id === row.id ? { ...t, name } : t)));
        setEditingId(null);
        setEditingName('');
        message.success('编辑成功');
    };

    const handleDelete = (row) => {
        onChange(list.filter(t => t.id !== row.id));
        if (editingId === row.id) { setEditingId(null); setEditingName(''); }
        message.success('删除成功');
    };

    const columns = [
        {
            title: '标签名称', key: 'name', width: 300,
            render: (_, record) => (
                editingId === record.id
                    ? <Input size="small" maxLength={50} value={editingName} onChange={e => setEditingName(e.target.value)} onPressEnter={() => handleSaveEdit(record)} />
                    : <span style={{ color: '#1677ff' }}>{record.name}</span>
            ),
        },
        {
            title: '操作', key: 'action', width: 200,
            render: (_, record) => (
                editingId === record.id ? (
                    <Space size={12}>
                        <Button type="link" size="small" icon={<SaveOutlined />} onClick={() => handleSaveEdit(record)}>保存</Button>
                        <Button type="link" size="small" icon={<CloseOutlined />} onClick={() => { setEditingId(null); setEditingName(''); }}>取消</Button>
                    </Space>
                ) : (
                    <Space size={12}>
                        <Button type="link" size="small" icon={<GlobalOutlined />} title="多语言配置" onClick={() => setI18n({ open: true, originValue: record.name })} />
                        <Button type="link" size="small" icon={<EditOutlined />} onClick={() => { setEditingId(record.id); setEditingName(record.name || ''); }}>编辑</Button>
                        <Popconfirm title="确定删除该标签？" okText="确定" cancelText="取消" okButtonProps={{ danger: true }} onConfirm={() => handleDelete(record)}>
                            <Button type="link" size="small" danger icon={<DeleteOutlined />}>删除</Button>
                        </Popconfirm>
                    </Space>
                )
            ),
        },
    ];

    return (
        <Modal title={dialogTitle} open={open} onCancel={onCancel} width={600} footer={null} destroyOnClose>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                <Input
                    value={inputName}
                    onChange={e => setInputName(e.target.value)}
                    placeholder="请输入标签名称"
                    allowClear
                    onPressEnter={handleAdd}
                />
                <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>添加</Button>
            </div>

            <Table
                dataSource={list}
                rowKey="id"
                columns={columns}
                pagination={false}
                size="small"
                scroll={{ x: 560 }}
            />

            <MultilingualDialog
                open={i18n.open}
                title={`${dialogTitle}—多语言翻译`}
                originValue={i18n.originValue}
                onCancel={() => setI18n({ open: false, originValue: '' })}
            />
        </Modal>
    );
};

export default TagDialog;
